module.exports = rnJQuery;